/**
 * Interpretação da resposta do webhook de cancelamento de boleto.
 *
 * Módulo separado de cancelarBoletoSicoob.ts de propósito: aqui não entra nada de
 * I/O (nem `supabase`), então dá para testar com `node --test` sem subir o Vite.
 *
 * ⚠️ O Sicoob usa o MESMO código 5002 para dois casos opostos:
 *
 *   - "Boleto já baixado/liquidado" → o boleto não é mais cobrável. É exatamente
 *     o que a gente queria: SUCESSO. Contar como falha gera alarme falso.
 *   - "Boleto não encontrado"       → sintoma de baixa pedida na conta errada.
 *     As duas contas Sicoob têm sequências próprias de nossoNumero, e o mesmo
 *     número existe nas duas apontando para boletos diferentes (ver
 *     sicoobAccount.ts). Engolir isso como sucesso esconderia o bug mais caro
 *     que existe nesse fluxo.
 *
 * Por isso o casamento é pela MENSAGEM, nunca pelo código — e "não encontrado" é
 * avaliado primeiro.
 */

const RE_NAO_ENCONTRADO = /n[ãa]o\s+(foi\s+)?encontrad/i;
const RE_JA_BAIXADO = /j[áa]\s+(foi\s+)?(baixad|liquidad)|liquidad[oa]/i;

export interface ClassificacaoCancelamento {
    ok: boolean;
    /** true quando o Sicoob respondeu que o boleto já estava baixado — sucesso, não erro. */
    jaBaixado: boolean;
}

export const classificarRespostaCancelamento = (corpo: string): ClassificacaoCancelamento => {
    if (RE_NAO_ENCONTRADO.test(corpo)) return { ok: false, jaBaixado: false };
    if (RE_JA_BAIXADO.test(corpo)) return { ok: true, jaBaixado: true };
    // Default pessimista: erro desconhecido é erro.
    return { ok: false, jaBaixado: false };
};
